export const type = 'setDialogoSoporteMostrado'
const setDialogoSoporteMostrado = () => ({ type, payload: '' })
export default setDialogoSoporteMostrado
